import { render, staticRenderFns } from "./SmsWhatsappTemplateSetup.vue?vue&type=template&id=6b54b8bb&scoped=true&lang=pug&"
import script from "./SmsWhatsappTemplateSetup.vue?vue&type=script&lang=js&"
export * from "./SmsWhatsappTemplateSetup.vue?vue&type=script&lang=js&"
import style0 from "./SmsWhatsappTemplateSetup.vue?vue&type=style&index=0&id=6b54b8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54b8bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VForm,VRow})
